import React, { useState } from "react";
import { cloudStorage } from "@telegram-apps/sdk";
import "./style.scss";

const PasswordInput = () => {
    const [password, setPassword] = useState("");

    const savePassword = async (password: string) => {
        if (process.env.NODE_ENV === "development") {
            localStorage.setItem("b4chat-password-hash-admin", password);
        } else {
            await cloudStorage.setItem("b4chat-password-hash-admin", password);
        }
    };

    const handleButtonClick = async () => {
        await savePassword(password);
        window.location.reload();
    };

    return (
        <div className="password-input">
            <div className="password-input_container">
                <div className="password-input_wrapper">
                    <span className="password-input_title">
                        Для активации аккаунта введите пароль, который Вам
                        сообщит менеджер Bot For Chat.
                    </span>
                    <input
                        type="password"
                        className="password-input_input"
                        placeholder=""
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <div className="password-input_btn" onClick={handleButtonClick}>
                        Активировать аккаунт
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PasswordInput;